import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';
import { getContracts } from '../../+state/account/masterdata/masterdata.selectors';
import { getPersonalData } from '../../+state/account/user-profile/user-profile.selectors';
import { getSelectedCustomerIdent } from '../../+state/account/user-apps/user-apps.selectors';
import { bAndOConfig } from './bAndODomainConfig';
import { contractStatusConverter } from '../account';

@Injectable()
export class CustomerService {
  private customerIdentsForBandODamageFlow: string[] = [
    'be32bb20-fd85-47af-8d1f-82785160d779', // LEG SBX
    '6b557caf-1766-4271-9489-d71873eac482', //VHW SBX
    'c05d8e95-6891-401a-93da-bfd8d7cf28c4', //VHW PROD
  ];
  private customerIdentsWithoutTicketManagement: string[] = [
    'e85c71a3-fc2d-4c7d-93ea-ede2922474c6', //GEBAUSIE STG
    'c73a5486-b9e5-3f28-31fa-a8ade4a2e061', // GEBAUSIE PROD
  ];

  readonly #store = inject(Store);
  readonly #customerIdent = this.#store.selectSignal(getSelectedCustomerIdent);

  public showBandODamageFlow() {
    return this.customerIdentsForBandODamageFlow.some(
      customerIdent => customerIdent === this.#customerIdent()
    );
  }

  public getBandODomain(isMobile?: boolean): string {
    return isMobile
      ? bAndOConfig[this.#customerIdent()]?.mobile
      : bAndOConfig[this.#customerIdent()]?.web;
  }

  public hideTicketManagement(): boolean {
    return this.customerIdentsWithoutTicketManagement.some(
      customerIdent => customerIdent === this.#customerIdent()
    );
  }

  public appPreviewMode(): Observable<boolean> {
    return combineLatest([
      this.#store.select(getContracts),
      this.#store.select(getPersonalData),
    ]).pipe(
      map(([contracts = [], personalData]) => {
        const hasNoValidContracts = !contracts.some(c => c.contractStartTime);
        const hasExpiredContracts = contractStatusConverter.allContractsExpired(contracts);
        const hasActiveMembership = personalData?.cooperativeData?.activeMembership;

        return hasNoValidContracts || (hasExpiredContracts && hasActiveMembership);
      })
    );
  }

  public onlyExpiredContractsAndActiveMembership(): Observable<boolean> {
    return combineLatest([
      this.#store.select(getContracts),
      this.#store.select(getPersonalData),
    ]).pipe(
      map(([contracts = [], personalData]) => {
        const onlyExpiredContracts = contractStatusConverter.allContractsExpired(contracts);
        const hasActiveMembership = personalData?.cooperativeData?.activeMembership;
        return hasActiveMembership && onlyExpiredContracts;
      })
    );
  }
}
